export default function cmdEnterToRun(e, callback) {
    if ((e.metaKey || e.ctrlKey) && (e.key === 'Enter' || e.keyCode === 13)) {
        callback();
    }
}
